<ng-container [formGroup]="formGroup">
  <div class="form-subtitle flex-basis-100 mb-16 text-16" i18n>
    Informations sur l'activité
  </div>

  <div
    class="row my-3"
    [ngClass]="{
      'row-cols-md-2 row-cols-sm-1': showStaffFields,
      'row-cols-md-1 row-cols-sm-1': !showStaffFields,
    }"
  >
    <div class="col">
      <label i18n>Domaine d'activité principale</label>
      <input type="text" class="form-control" formControlName="activityArea" />
    </div>
    <div class="col" *ngIf="showStaffFields">
      <label i18n>Nombre de collaborateurs</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="collaboratorsCount"
      />
    </div>
  </div>

  <div class="row my-3">
    <div class="col">
      <label i18n>Description de l'activité</label>
      <textarea
        class="form-control"
        rows="3"
        formControlName="activityDescription"
      ></textarea>
    </div>
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>A une convention collective de travail</label>
      <div class="form-check">
        <input
          type="radio"
          name="hasLaborAgreement"
          id="hasLaborAgreementFalse"
          [value]="false"
          formControlName="hasLaborAgreement"
        />
        <label class="form-check-label" for="hasLaborAgreementFalse">
          Non
        </label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="hasLaborAgreement"
          id="hasLaborAgreementTrue"
          [value]="true"
          formControlName="hasLaborAgreement"
        />
        <label class="form-check-label" for="hasLaborAgreementTrue">
          Oui
        </label>
      </div>
    </div>
    <div
      class="col"
      *ngIf="
        formGroup.value.hasLaborAgreement === 'true' ||
        formGroup.value.hasLaborAgreement === true
      "
    >
      <label i18n>Convention collective</label>
      <input
        type="text"
        class="form-control"
        formControlName="laborAgreement"
      />
    </div>
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3" *ngIf="showActivityFields">
    <div class="col">
      <label i18n>Activité internationale</label>
      <div class="form-check">
        <input
          type="radio"
          name="isInternational"
          id="isInternationalFalse"
          [value]="false"
          formControlName="isInternational"
        />
        <label class="form-check-label" for="isInternationalFalse"> Non </label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="isInternational"
          id="isInternationalTrue"
          [value]="true"
          formControlName="isInternational"
        />
        <label class="form-check-label" for="isInternationalTrue"> Oui </label>
      </div>
    </div>
    <div
      class="col"
      *ngIf="
        formGroup.value.isInternational === 'true' ||
        formGroup.value.isInternational === true
      "
    >
      <label i18n>Pays d'activité</label>
      <mat-form-field class="lty-input">
        <mat-select
          [formControl]="getControl(formGroup.controls['activityCountries'])"
          multiple
        >
          <mat-option
            *ngFor="let countryCode of countriesISO"
            [value]="countryCode"
          >
            {{ getCountryName(countryCode) }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="row my-3" *ngIf="showActivityFields">
    <div class="col">
      <label i18n>Emploie des sous-traitants</label>
      <div class="form-check">
        <input
          type="radio"
          name="hasSubcontractors"
          id="hasSubcontractorsFalse"
          [value]="false"
          formControlName="hasSubcontractors"
        />
        <label class="form-check-label" for="hasSubcontractorsFalse">
          Non
        </label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="hasSubcontractors"
          id="hasSubcontractorsTrue"
          [value]="true"
          formControlName="hasSubcontractors"
        />
        <label class="form-check-label" for="hasSubcontractorsTrue">
          Oui
        </label>
      </div>
    </div>
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3" *ngIf="showStaffFields">
    <div class="col">
      <label i18n>Chiffre d'affaires annuel brut (CHF)</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="yearlyAnnualRevenue"
      />
    </div>
    <div class="col">
      <label i18n>Masse salariale annuelle (CHF)</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="yearlySalaries"
      />
    </div>
  </div>
</ng-container>
